import * as ActionTypes from '../../actions/actionTypes'

const initialState = {
    pendingPushYearPrices: false,
    pendingPushYearRestrictions: false,
    pendingInventoryAvailability: false
}

/** @reducer **/
export default (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.H24_PUSH_YEAR_PRICES_REQUEST:
            return { ...state, pendingPushYearPrices: true }
        case ActionTypes.H24_PUSH_YEAR_PRICES_SUCCESS:
        case ActionTypes.H24_PUSH_YEAR_PRICES_FAILURE:
            return { ...state, pendingPushYearPrices: false }

        case ActionTypes.H24_PUSH_YEAR_RESTRICTIONS_REQUEST:
            return { ...state, pendingPushYearRestrictions: true }
        case ActionTypes.H24_PUSH_YEAR_RESTRICTIONS_SUCCESS:
        case ActionTypes.H24_PUSH_YEAR_RESTRICTIONS_FAILURE:
            return { ...state, pendingPushYearRestrictions: false }

        case ActionTypes.H24_INVENTORY_AVAILABILITY_REQUEST:
            return { ...state, pendingInventoryAvailability: true }
        case ActionTypes.H24_INVENTORY_AVAILABILITY_SUCCESS:
        case ActionTypes.H24_INVENTORY_AVAILABILITY_FAILURE:
            return { ...state, pendingInventoryAvailability: false }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/h24Reducers/h24Sync.js